import { UserProfileResponse } from '@rendernet/api-client';
import { formatProfileData } from 'core/utils/utils';

class GetProfileResponse {
	userProfile: UserProfileResponse;

	constructor(userProfileResponse: UserProfileResponse) {
		this.userProfile = userProfileResponse;
	}

	formatResponse() {
		return formatProfileData(this.userProfile);
	}
}

export default GetProfileResponse;
